module.exports = __webpack_public_path__ + "media/images/area/feature/kyushu/related/vi_4-24cf661cdccaac838660d287e78827e1.jpg";